<template>
    <div>
        <loading :dspin="displayLoading"></loading>

        <div v-if="!displayLoading">
            <form class="flow-form-cum-panel w3-col">
                <div v-model="successMessage" class="successMessage"
                     :style="successMessage ? 'display:block' : 'display:none'">
                    {{successMessage}}
                    <span class="w3-right cursor-pointer w3-text-red" @click="successMessage = ''">
                        <i class="fa fa-times-circle"></i>
                    </span>
                </div>
                <div class="w3-container flow-padding-top">
                    <p class="w3-col w-45pc flow-form-inline-input">
                        <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("name") }}</label>
                        <input class="w3-input" v-bind:class="nameError ? 'error' : ''" type="text"
                               v-bind:placeholder="$t('enter.name')" v-model="name">
                        <span class="w3-text-red"> {{ nameError }} </span>
                    </p>
                    <p class="w3-col w-45pc flow-form-inline-input w3-right">
                        <label class="w3-left flow-blue-color flow-padding-bottom w-100pc">{{ $t("time") }}</label>
                        <input class="w3-input w-80pc w3-show-inline-block time-picker-trigger" type="text"
                               v-bind:placeholder="$t('select.time')"
                               v-bind:class="timeError ? 'error' : ''"
                               @click="openTimePicker = !openTimePicker"
                               v-bind:value="appointmentTime.val"/>
                        <i class="far fa-clock w3-large flow-blue-color flow-padding-left cursor-pointer w3-ripple time-picker-trigger"
                           @click="openTimePicker = !openTimePicker" :title="$t('openTimePicker')"></i>
                        <span class="w3-text-red"> {{ timeError }} </span>
                    </p>

                    <p class="w3-col w-90pc flow-form-inline-input time-picker-container">
                        <time-picker v-if="openTimePicker"
                                     class="flow-card w3-animate-opacity"
                                     :onChange="onChange"
                                     :preSelected="appointmentTime"
                                     :onClose="()=>{openTimePicker = false;}">
                        </time-picker>
                    </p>
                </div>

                <div class="w3-container zero-top">
                    <p v-bind:class="physicians.length < 1 ? 'w3-disabled' : ''"
                       class="w3-col w-45pc flow-form-inline-input">
                        <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("physicians") }}</label>
                        <flow-select :items="physicians" :valueKey="'name'" :valueKeyIndex="'id'"
                                     :preSelectedItem="physician"
                                     :callback="selectPhysician"></flow-select>
                    </p>
                    <p v-bind:class="groups.length < 1  ? 'w3-disabled' : ''"
                       class="w3-col w-45pc flow-form-inline-input w3-right">
                        <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("appointmentTypes") }}</label>
                        <flow-select :items="groups" :valueKey="'displayName'" :valueKeyIndex="'id'"
                                     :preSelectedItem="group" :callback="selectGroup"></flow-select>
                    </p>
                </div>
                <div class="w3-container zero-top " :style="noAppointmentsMessage ? 'display:block' : 'display:none'">
                    <p class="flow-form-inline-input w3-text-red">{{noAppointmentsMessage}}</p>
                </div>

                <div class="w3-container zero-top">
                    <p class="w3-col w-45pc flow-form-inline-input">
                        <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("tag") }}</label>
                        <input v-bind:class="this.tagError ? 'error' : ''" class="w3-input" type="text"
                               v-bind:placeholder="$t('enter.tag')" v-model="ticket">
                        <span class="w3-text-red"> {{ tagError }} </span>
                    </p>
                    <p class="w3-col w-45pc flow-form-inline-input w3-right">
                        <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("dobRequired") }}</label>
                        <input v-bind:class="this.dobError ? 'error' : ''" class="w3-input" type="text" v-model="dob" placeholder="dd-mm-yyyy" :title="$t('INVALID_DOB_FORMAT')">
                        <span class="w3-text-red"> {{ dobError }} </span>
                    </p>
                </div>

                <div class="w3-container zero-top">
                    <p class="w3-col w-45pc flow-form-inline-input" v-if="isDH">
                        <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("assignedRoom") }}</label>
                        <input class="w3-input" type="text" v-bind:placeholder="$t('enter.room')" v-model="room">
                    </p>
                </div>

                <div class="w3-container zero-top">
                    <p class="flow-form-inline-input">
                        <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-left w3-margin-right w3-margin-top w3-large"
                                @click.prevent="save">
                            <i class="fa fa-save flow-green-active-color">
                                <span><b class="flow-margin-left">{{$t('save')}}</b></span>
                            </i>
                        </button>
                    </p>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import FlowSelect from "../common/FlowSelect";
    import TimePicker from "../common/TimePicker";
    import Loading from "../common/Loading";
    import {EventBus} from "../../main";

    const frc = Vue.prototype.$frc;

    export default {
        name: "NewPatientDashboard",
        components: {Loading, TimePicker, FlowSelect},
        props: ['onClose', 'specialWard', 'specialWardsIds', 'isDH'],
        data() {
            return {
                name: '',
                appointmentTime: '',
                group: undefined,
                physician: undefined,
                groups: [],
                physicians: [],
                openTimePicker: false,
                displayLoading: false,
                nameError: '',
                timeError: '',
                tagError: '',
                patients: [],
                successMessage: '',
                patient: undefined,
                noAppointmentsMessage: '',
                ticket: undefined,
                room: '',
                dob: '',
                dobError: ''
            }
        },
        mounted() {
            this.checkWardAndUpdate();
        },
        watch: {
            specialWard(newValue) {
                this.checkWardAndUpdate();
            }
        },
        methods: {
            checkWardAndUpdate() {
                var app = this;
                if (app.specialWard) {
                    app.physicians = [];
                    app.physician = undefined;
                    app.groups = [];
                    app.group = undefined;
                    app.noAppointmentsMessage = '';
                    app.getPhysiciansForSpecialWards();
                    app.getGroupsForSpecialWards();
                } else {
                    frc.getAllPhysicians().then(function (res) {
                        var physicians = res.data;
                        app.physicians = [];
                        app.physician = undefined;
                        physicians.forEach(function (p) {
                            var special = app.specialWardsIds.includes(p.ward.id);
                            if (!special) {
                                app.physicians.push(p);
                            }
                        });
                        Vue.sortByKey(app.physicians, 'name');
                    }).catch(function (ex) {
                        console.log(ex);
                    });
                }

            },
            getPhysiciansForSpecialWards() {
                var app = this;
                var wards = app.specialWardsIds;
                app.physicians = [];
                wards.forEach(function (wid) {
                    frc.getPhysiciansInWard(wid).then(function (res) {
                        var physicians = res.data;
                        physicians.forEach(function (p) {
                            app.physicians.push(p);
                        });
                        Vue.sortByKey(app.physicians, 'name');
                    }).catch(function (ex) {
                        console.log(ex);
                    });
                });
            },
            getGroupsForSpecialWards() {
                var app = this;
                var wards = app.specialWardsIds;
                app.groups = [];
                wards.forEach(function (wid) {
                    frc.getConsultationGroupsInWard(wid).then(function (res) {
                        var groups = res.data;
                        groups.forEach(function (g) {
                            g.ward = wid;
                            app.groups.push(g);
                        });
                        Vue.sortByKey(app.groups, 'displayName');
                    }).catch(function (ex) {
                        console.log(ex);
                    });
                })
            },
            onChange(time) {
                this.appointmentTime = time;
            },
            selectPhysician(physician) {
                if (physician) {
                    this.physician = physician;
                    if (!this.specialWard) {
                        this.getCGForPhysician(physician)
                    }
                }
            },
            getCGForPhysician(physician) {
                var app = this;
                frc.getAppointmentGroupsForPhysician(physician.id).then(function (res) {
                    app.groups = res.data;
                    Vue.sortByKey(app.groups, 'displayName');
                    app.group = app.groups[0];
                    app.noAppointmentsMessage = '';
                    if (app.groups.length === 0) {
                        app.noAppointmentsMessage = app.$t("noAppointmentsToday");
                    }
                }).catch(function (ex) {
                    console.log(ex);
                })
            },
            selectGroup(group) {
                if (!group) {
                    return;
                }
                this.group = group;
            },
            save() {
                this.nameError = '';
                this.timeError = '';
                this.dobError = '';
                var dateFormatCheck = /^(0[1-9]|[12][0-9]|3[01])[-](0[1-9]|1[012])[-](18|19|20)\d\d$/.test(this.dob);
                var today = new Date();
                var rawFormatDate = this.dob === '' ? '' : new Date(Vue.getYMDFromDMY(this.dob));
                var ageInYears = (today - rawFormatDate) / 31556952000;

                if (!(this.name && this.name.trim())) {
                    this.nameError = this.$t("INVALID_NAME");
                    return;
                }

                if (!(this.appointmentTime && this.appointmentTime.val && this.appointmentTime.val.trim())) {
                    this.timeError = this.$t("INVALID_TIME");
                    return;
                }

                if (!this.group) {
                    this.name = '';
                    this.appointmentTime = '';
                    this.noAppointmentsMessage = '';
                    Vue.notifyError({message: this.$t("noAppointmentsToday")});
                    return;
                }

                if (this.dob !== '' && !dateFormatCheck) {
                    this.dobError = this.$t("INVALID_DOB_FORMAT");
                    return;
                }

                if (this.dob !== '' && (ageInYears > 110 || ageInYears < 0)) {
                    this.dobError = this.$t("INVALID_DOB");
                    return;
                }

                if (this.dob !== '' && this.group.id === 'dh.ort.minors' && ageInYears > 18) {
                    this.dobError = this.$t("INVALID_DOB_MINOR");
                    return;
                }

                if (this.dob !== '' && this.group.id === 'dh.ort.adults' && ageInYears < 14) {
                    this.dobError = this.$t("INVALID_DOB_ADULT");
                    return;
                }

                const app = this;
                app.displayLoading = true;
                var wid = this.specialWard ? app.group.ward : app.physician.ward.id;
                var dob = app.group.id==='dh.ort.minors' && app.dob==='' ? Vue.setDateObjectToYMD(today) : Vue.setDateObjectToYMD(rawFormatDate);

                frc.createPatientWithAppointment(
                    wid, {
                        name: app.name,
                        appointmentTime: app.appointmentTime.val,
                        physicianId: app.physician.id,
                        groupId: app.group.id,
                        positionId: 'subscriptions',
                        ticket: app.ticket,
                        assignedRoom: app.room ? app.room : '',
                        dob: dob
                    }).then(function (res) {
                    if (res.data && res.data.value) {
                        app.name = '';
                        app.room = '';
                        app.appointmentTime = '';
                        app.ticket = undefined;
                        var patientId = res.data.value;
                        Vue.notifySuccess({title: app.$t("patientSuccessfullyCreated")});
                        EventBus.$emit("newPatientCreated", res.data.value);

                        frc.getSLWPatient(patientId).then(function (res) {
                            var patient = res.data;
                            app.successMessage = app.$t("patientCreatedMessage", {
                                "patient": patient.name,
                                "ticket": patient.ticket
                            });
                        }).catch(function (ex) {
                            console.log(ex);
                        });
                    } else {
                        console.log("Something went wrong!");
                    }
                    app.displayLoading = false;
                }).catch(function (ex) {
                    app.displayLoading = false;
                    if (!ex.restCodes) {
                        return;
                    }

                    if (ex.restCodes.includes("INVALID_NAME")) {
                        app.nameError = app.$t("INVALID_NAME");
                    }

                    if (ex.restCodes.includes("INVALID_TIME")) {
                        app.timeError = app.$t("INVALID_TIME");
                    }

                    if (ex.restCodes.includes("INVALID_BADGE")) {
                        app.tagError = app.$t("INVALID_BADGE");
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>